import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { SubmissionService } from '../../../shared/submission.service';

/**
 * Shown after a submission is moved to `won` (Placed). Prompts the recruiter
 * to create the delivery project immediately, optionally providing start/end
 * dates. Closes with the created Project object on success, or null when the
 * user chooses to skip ("Just mark placed").
 */
@Component({
  selector: 'bst-convert-project-dialog',
  templateUrl: './convert-project-dialog.component.html',
  styleUrls: ['./convert-project-dialog.component.scss'],
  standalone: false,
})
export class ConvertProjectDialogComponent {

  /** Set via NbDialog context. */
  consultantName = '';
  opportunityTitle = '';
  submissionId = 0;

  start: Date | null = null;
  end: Date | null = null;
  saving = false;
  errorKey: string | null = null;

  constructor(
    private ref: NbDialogRef<ConvertProjectDialogComponent>,
    private submissionService: SubmissionService,
  ) {}

  skip(): void {
    this.ref.close(null);
  }

  async create(): Promise<void> {
    this.errorKey = null;

    if (this.start && this.end && this.end < this.start) {
      this.errorKey = 'crm.convert.error_date_order';
      return;
    }

    this.saving = true;
    try {
      const startIso = this.start ? this.formatDate(this.start) : undefined;
      const endIso   = this.end   ? this.formatDate(this.end)   : undefined;
      const project = await this.submissionService.convertToProject(this.submissionId, startIso, endIso, [400, 422]);
      this.saving = false;
      this.ref.close(project);
    } catch (e) {
      console.error('convertToProject failed', e);
      this.errorKey = 'crm.convert.error';
      this.saving = false;
    }
  }

  /** Format a Date as YYYY-MM-DD without timezone shift. */
  private formatDate(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
}
